export default {"src":"/_next/static/media/pie.ccea03ab.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};